// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CreatedShareableBusinessCardRow,
} from "./types";

export const params = {
  cardId: __t.uuid(),
  accessCode: __t.option(__t.string()),
  browsable: __t.option(__t.bool()),
};
export const returnType = CreatedShareableBusinessCardRow